import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import BasicSelect from "./BasicSelect";
import Form from 'react-bootstrap/Form';

import '../css/wl-chart.css'
import { dividerClasses } from "@mui/material";

function WLChart({ sportcode, google, teams, opps, seasons, location, teamid }) {
    
    const isNFL = () => sportcode === "NFL" ? true : false;

    let pointLabel = isNFL() ? "Point" : "Run"


    const [loading, setLoading] = useState(true);
    const [top, setTop] = useState(isNFL() ? 10 : 5);
    const [interval, setInterval] = useState(isNFL() ? 3 : 1);
    const [summary, setSummary] = useState(null);
    const [maxtop, setMaxTop] = useState((sportcode === "NFL" ? 21 : 11));
    const [sortPointDiff, setSortPointDiff] = useState(false);

    const tpItems = [];
    for (var i = 1; i < maxtop; i++) {
        tpItems.push({ value: i, text: i.toString() });
    }

    const [topItems, setTopItems] = useState(tpItems);

    const intervalItems = [];
    for (var i = 1; i < 10; i++) {
        intervalItems.push({ value: i, text: i.toString() });
    }

    const onIntervalChange = (e, selectedvalue) => {
        setInterval(selectedvalue);
        drawChart(summary, selectedvalue, top, sortPointDiff, maxtop);
    }

    const onTopChange = (e, selectedvalue) => {
        setTop(selectedvalue);
        drawChart(summary, interval, selectedvalue, sortPointDiff, maxtop);
    }

    const handleSortPointDiffChange = (e) => {
        let isSorted = e.target.checked;
        setSortPointDiff(isSorted);
        drawChart(summary, interval, top, isSorted, maxtop);
    }

    const drawChart = (summary, interval_value, top_value, sortByPointDiff, mtop) => {

        // Create the data table.
        let data_arr = [];
        data_arr.push(['PointDif+Result', 'Games', { role: 'style' }, { type: 'string', role: 'tooltip' }]);
        
        if (summary) {

            let wl_diff = [];

            let add_data = function (min, max, top_value) {

                let win_total_value = 0;
                let loss_total_value = 0;
                let games_win = [];
                let games_loss = [];

                for (let i = min; i <= max; i++) {

                    let key_win = 'Win' + i;
                    let key_loss = 'Loss' + i;

                    win_total_value += summary[key_win] ? summary[key_win].Total : 0;
                    loss_total_value += summary[key_loss] ? summary[key_loss].Total : 0;
                    if (summary[key_win]) {
                        games_win = games_win.concat(summary[key_win].Games);
                    }
                    if (summary[key_loss]) {
                        games_loss = games_loss.concat(summary[key_loss].Games);
                    }
                }

                let fngetgamesdesc = function (gms) {

                    return gms.sort(function (a, b) {
                        return b.gdate - a.gdate
                    }).map(function (g) {
                        return g.desc
                    }).join('\n ')

                };

                if (min == top_value) {
                    wl_diff.push({
                        index: max, win: true, cols: [`${min}+ ${pointLabel} Win`, win_total_value, 'color: #dc3545', fngetgamesdesc(games_win)]
                    });
                    wl_diff.push({
                        index: max, win: false, cols: [`${min}+ ${pointLabel} Loss`, loss_total_value, 'color: #0d6efd', fngetgamesdesc(games_loss)]
                    });
                }
                else if (min == max) {
                    wl_diff.push({
                        index: max, win: true, cols: [`${min} ${pointLabel} Win`, win_total_value, 'color: #dc3545', fngetgamesdesc(games_win)]
                    });
                    wl_diff.push({
                        index: max, win: false, cols: [`${min} ${pointLabel} Loss`, loss_total_value, 'color: #0d6efd', fngetgamesdesc(games_loss)]
                    });
                }
                else {
                    wl_diff.push({
                        index: max, win: true, cols: [`${min}-${max} ${pointLabel} Win`, win_total_value, 'color: #dc3545', fngetgamesdesc(games_win)]
                    });
                    wl_diff.push({ index: max, win: false, cols: [`${min}-${max} ${pointLabel} Loss`, loss_total_value, 'color: #0d6efd', fngetgamesdesc(games_loss)] });
                }

            }

            const fngetmax = function (min, range, top_val) {

                let max = min + (range - 1)

                if (min == top_val) {
                    max = mtop;
                }
                else if (max >= top_val) {
                    max = top_val - 1;
                }

                return max;
            }

            let min = 1;
            let max = fngetmax(min, interval_value, top_value);

            while (min <= top_value) {
                add_data(min, max, top_value);
                min = max + 1;
                max = fngetmax(min, interval_value, top_value);
            }


            if (wl_diff && wl_diff.length > 0) {

                if (sortByPointDiff == true) {
                    wl_diff.sort((b, a) => {
                        // either win/lose: sort win first
                        if (a.win == true && b.win == false) {
                            return -1;
                        } else if (a.win == false && b.win == true) {
                            return 1;
                        } else {
                            // both win, sort desc
                            if (a.win == true) {
                                return b.index - a.index;
                            }
                            // both loss, sort asc
                            else {
                                return a.index - b.index; // corrected the order of subtraction
                            }
                        }
                    });


                }
                else {

                    wl_diff.sort((b, a) => {

                        let diff = b.cols[1] - a.cols[1];

                        if (diff == 0) {
                            return b.index - a.index;
                        }
                        else {
                            return diff;
                        }
                    });

                }

                for (let i = 0; i < wl_diff.length; i++) {

                    data_arr.push(wl_diff[i].cols);
                }

            }



        }
        else {
            data_arr.push(['', 0, 'color: red']);
        }

        const data = google.visualization.arrayToDataTable(data_arr);

        var view = new google.visualization.DataView(data);
        view.setColumns([0, 1,
            {
                calc: "stringify",
                sourceColumn: 1,
                type: "string",
                role: "annotation"
            },
            2,
            3]);

        var interval = 1;
        var dataRange = data.getColumnRange(1);

        var vTicks = [];
        for (var i = dataRange.min; i <= dataRange.max + interval; i = i + interval) {
            vTicks.push(i);
        }

        // Set chart options
        var options = {
            title: "WIN-LOSS SUMMARY",

            chartArea: { width: '100%' },
            height: 550,
            bar: { groupWidth: "70%" },
            legend: { position: "none" },
            tooltip: { isHtml: true },
            vAxis: {
                ticks: vTicks
            },
            hAxis: {
                direction: -1,
                slantedText: true,
                slantedTextAngle: 90 

            },
        };

        // Instantiate and draw our chart, passing in some options.
        const newChart = new google.visualization.ColumnChart(document.getElementById('chart_div'));
        newChart.draw(view, options);

    }

    useEffect(() => {
        
        Load();

        //window.addEventListener('resize', handleResize)
        //return () => window.removeEventListener('resize', handleResize);

    }, [google, teams, opps, seasons, location]);

    const Load = () => {

        if (google) {

            async function fetchData() {
                const resp = await fetch(`/${sportcode}/WinLossSummaryChart`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        TeamIds: teams,
                        OppIds: opps,
                        SeasonIds: seasons
                    })
                });
                let games = await resp.json();
                location = location.toLowerCase()
                if (location !== "all") {
                    const isAway = location === "away";
                    const isHome = location === "home";

                    games = games.filter(x =>
                        (isAway && x.VisitorTeamId === teamid) ||
                        (isHome && x.HomeTeamId === teamid)
                    );
                }

                //console.log("WlChartGames", games)

                let wlsummary = {};
                if (games) {

                    let mtop = maxtop;

                    for (var i = 0; i < games.length; i++) {

                        let g = games[i];
                        let wl = (g.TeamPoints > g.OppPoints) ? "Win" : "Loss";
                        let diff = (g.TeamPoints > g.OppPoints) ? g.TeamPoints - g.OppPoints : g.OppPoints - g.TeamPoints;

                        if (diff > mtop) {
                            mtop = diff;
                        }

                        let key = wl + diff;

                        const vsAt = teamid === g.VisitorTeamId ? "@" : "vs"

                        let game = {
                            gdate: Date.parse(g.GameDate),
                            desc: `${g.GameDate} ${vsAt} ${g.OppTeam} ${g.TeamPoints}-${g.OppPoints}`
                        };

                        if (!(key in wlsummary)) {
                            wlsummary[key] = {
                                Total: 1,
                                Games: [game]
                            };
                        }
                        else {
                            wlsummary[key].Total++;
                            wlsummary[key].Games.push(game);
                        }

                    }

                    if (mtop > maxtop) {
                        setMaxTop(mtop);
                    }                    
                    setSummary(wlsummary);
                    drawChart(wlsummary, interval, top, sortPointDiff, mtop);
                }


                setLoading(false);


            }

            fetchData();

        }

    }

    return (
        <>
            {
                !google &&
                <div className="col-lg-12 flex text-center"><Spinner /></div>
            }

            <div className={!google ? 'd-none' : ''}>

                <div className="d-grid justify-content-center" id="chart_div" />

                <hr />

                <div className="wl-responsive-inputs">
                    <div className="wl-inputs">
                        <BasicSelect
                            items={intervalItems}
                            labelId="intervalLabel"
                            labelText="Interval"
                            selectId="selectInterval"
                            onChange={onIntervalChange}
                            defaultValues={interval}
                        >
                        </BasicSelect>
                    </div>
                    <div className="wl-inputs">
                        <BasicSelect
                            items={topItems}
                            labelId="topLabel"
                            labelText="Top"
                            selectId="selectTop"
                            onChange={onTopChange}
                            defaultValues={top}
                        >
                        </BasicSelect>
                    </div>
                    <div className="wl-inputs">
                        <Form>
                            <Form.Check
                                checked={sortPointDiff}
                                onChange={handleSortPointDiffChange}
                                type="switch"
                                id="sortSwitch"
                                label={`Sort By ${pointLabel} Diff`}
                                className="mx-2"
                            />
                        </Form>
                    </div>

                </div>



            </div>

        </>
    )

}

export default WLChart;